// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kC7o","top":"styles_top__1j2yp"};